import { all, fork } from 'redux-saga/effects';

import listenOpenPayouts from './listenOpenPayouts';

export default function* paymentsAndPayoutsPageSaga() {
  yield all([fork(listenOpenPayouts)]);
}
